import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../core/services/globals.service";
export class RadiationMachineService {
    constructor(http, globals) {
        this.http = http;
        this.globals = globals;
    }
    // Add your service methods here
    getMachineTypes() {
        let url = `${this.globals.dataUrl}machineType`;
        return this.http.get(url);
    }
    getMachinePurposes() {
        let url = `${this.globals.dataUrl}machinePurpose`;
        return this.http.get(url);
    }
    createMachine(machineData) {
        let url = `${this.globals.dataUrl}radiationMachine`;
        console.log(machineData, url);
        return this.http.post(url, machineData);
    }
    getMachineById(id) {
        let url = `${this.globals.dataUrl}radiationMachine/requirement/${id}`;
        return this.http.get(url);
    }
    updateMachine(id, machineData) {
        let url = `${this.globals.dataUrl}radiationMachine/${id}`;
        return this.http.put(url, machineData);
    }
    editMachine(id, machineData) {
        let url = `${this.globals.dataUrl}radiationMachine/${id}`;
        return this.http.put(url, machineData);
    }
    deleteMachine(id) {
        let url = `${this.globals.dataUrl}radiationMachine/${id}`;
        return this.http.delete(url);
    }
    getCostByProcessId(processId) {
        let url = `${this.globals.dataUrl}radiationMachine/${processId}/costs`;
        return this.http.get(url);
    }
    getInspectionMachineTransactions(page, pageSize, term) {
        let url = `${this.globals.dataUrl}radiationMachine/inspectionMachineTransactions?page=${page}&size=${pageSize}&term=${term}`;
        return this.http.get(url);
    }
    getByProponentId(proponentId, page, pageSize) {
        let url = `${this.globals.dataUrl}radiationMachine/proponent?proponentId=${proponentId}&page=${page}&size=${pageSize}`;
        return this.http.get(url);
    }
    getAllByProponentId(proponentId) {
        let url = `${this.globals.dataUrl}radiationMachine/proponentAll/${proponentId}`;
        return this.http.get(url);
    }
    inspectionUpsert(inspectionData) {
        let url = `${this.globals.dataUrl}radiationMachine/inspection`;
        return this.http.post(url, inspectionData);
    }
    getInspectionByUserProcessId(userProcessId) {
        let url = `${this.globals.dataUrl}radiationMachine/inspection/${userProcessId}`;
        return this.http.get(url);
    }
}
RadiationMachineService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RadiationMachineService_Factory() { return new RadiationMachineService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.GlobalsService)); }, token: RadiationMachineService, providedIn: "root" });
